import { myIcons } from "@/utils/icons"
import { motion } from "framer-motion"
import "./style.css";
import { t } from "i18next";

export const Education = () => {
    return <div
        style={{ color: 'var(--color-text)', }}
    >
        <p
            style={{
                fontSize: '25px',
                marginBottom: '20px',
            }}
        >{t("education-title")}</p>
        <EducationItem icon={myIcons.experiences.baun} school={t("my-uni")} department={t("my-uni-major")} degree="3.37 / 4.00" year="2021-2025" />
        <EducationItem icon={myIcons.experiences.afl} school={t("my-highschool")} department={t("my-highschool-major")} degree="82,26 / 100" year="2016-2020" />
    </div>
}

interface EducationItemPropsI {
    icon: string,
    school: string
    department: string
    degree: string
    year: string
}

const EducationItem = ({ icon, school, department, degree, year }: EducationItemPropsI) => {
    const isUni = icon == myIcons.experiences.baun;
    return <motion.div
        className="education-item"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.1 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        style={{
            display: 'flex',
            gap: '20px',
            marginBottom: '30px'
        }}
    >
        <div
            style={{
                display: 'flex',
                backgroundColor: '#dcdcdcff',
                alignItems: 'center',
                width: '50px',
                height: '50px',
                padding: '5px',
                borderRadius: '10px',
                boxShadow: '0 2px 8px rgba(33, 33, 33, 0.5)',
            }}
        >
            <img
                style={{
                    display: 'flex',
                    width: '100%',
                }}
                src={icon} alt="" />
        </div>

        <div>
            <p style={{ fontWeight: 'bold' }} >{school}</p>
            <p>{department}</p>
            <p
                style={{
                    backgroundColor: '#3f51b5',
                    display: 'inline-block',
                    padding: '2px 5px',
                    borderRadius: '5px',
                    color: 'white',
                    userSelect: 'none',
                    margin: '10px 10px 10px 0px'
                }}
            >
                {degree}
            </p>
            <p
                style={{
                    backgroundColor: '#3f51b5',
                    display: isUni ? 'inline-block' : 'none',
                    padding: '2px 5px',
                    borderRadius: '5px',
                    color: 'white',
                    userSelect: 'none',
                    margin: '10px 0px 10px 0px'
                }}
            >
                {t('reward')}
            </p>

            <p>{year}</p>
        </div>

    </motion.div>
}